import styled from 'styled-components';

const StyledRow = styled.div`
  margin-bottom: 0.5rem;
  position: relative;
`;

const StyledRemoveButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  color: ${({ theme }) => theme.colors.dangerText};
  font-size: 11px;
  padding: 0 0.375rem;
`;

const StyledHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
`;

const StyledLabel = styled.label`
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.3rem;
`;

const StyledTypeBadge = styled.span`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 10.5px;
  font-weight: 400;
`;

const StyledRequiredMark = styled.span`
  color: ${({ theme }) => theme.colors.dangerText};
  font-weight: 700;
`;

const StyledRequiredWarning = styled.span`
  color: ${({ theme }) => theme.colors.warning};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const StyledFullWidthInput = styled.input`
  width: 100%;
`;

const StyledExpressionWrapper = styled.div``;

const StyledExpressionTextarea = styled.textarea`
  width: 100%;
  font-family: monospace;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  background: ${({ theme }) => theme.colors.surface};
  resize: vertical;
  box-sizing: border-box;
`;

const StyledStepOutputColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

const StyledSelect = styled.select`
  width: 100%;
`;

export default {
  StyledRow,
  StyledRemoveButton,
  StyledHeader,
  StyledLabel,
  StyledTypeBadge,
  StyledRequiredMark,
  StyledRequiredWarning,
  StyledFullWidthInput,
  StyledExpressionWrapper,
  StyledExpressionTextarea,
  StyledStepOutputColumn,
  StyledSelect,
};
